export const MINI_AUDIO_PLAYER_SELECTOR = '[data-mini-audio-player]';
export const TOAST_DEFAULT_BOTTOM_PX = 24;
export const TOAST_PLAYER_GAP_PX = 8;

/**
 * Returns the toast `bottom` offset in pixels.
 * When a visible mini audio player is on screen, the toast sits above it.
 * Otherwise it uses the default bottom spacing.
 */
export function getMiniAudioPlayerBottomOffset(): number {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return TOAST_DEFAULT_BOTTOM_PX;
  }

  const players = document.querySelectorAll<HTMLElement>(
    MINI_AUDIO_PLAYER_SELECTOR
  );

  for (const player of players) {
    const rect = player.getBoundingClientRect();

    if (rect.height <= 0 || rect.width <= 0) {
      continue;
    }

    return Math.round(window.innerHeight - rect.top + TOAST_PLAYER_GAP_PX);
  }

  return TOAST_DEFAULT_BOTTOM_PX;
}
